import React from 'react';
type Tone = 'neon' | 'amber' | 'neutral' | 'green';
const tones: Record<Tone, string> = {
  neon: 'bg-neon/15 text-neon-soft ring-1 ring-inset ring-neon/40',
  amber: 'bg-amber-400/15 text-amber-300 ring-1 ring-inset ring-amber-400/35',
  neutral: 'bg-white/8 text-white/80 ring-1 ring-inset ring-white/15',
  green: 'bg-emerald-400/12 text-emerald-300 ring-1 ring-inset ring-emerald-400/30'
};
export function Badge({
  tone = 'neutral',
  children
}: {
  tone?: Tone;
  children: React.ReactNode;
}) {
  return <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide ${tones[tone]}`} data-id="element-569" data-mp="7p9gksypghda">
      {children}
    </span>;
}